import React from "react";
import { Route, RouteProps } from "react-router-dom";
import { AppContainer } from "../containers/App";
import { ErrorContainer } from "../containers/Error";
import { UserContainer } from "../containers/User";
import { AuthService } from "../services/AuthService";

/**
 * 認証制御用 Route モジュール
 * @param props RouteProps
 */
const AuthGuardRoute = (props: RouteProps) => {
  const appContainer = AppContainer.useContainer();
  const errorContainer = ErrorContainer.useContainer();
  const userContainer = UserContainer.useContainer();
  const user = userContainer.user;

  if (user.id || user.isAuthInvalid) {
    // 認証済みの場合
    return <Route {...props} />;
  } else {
    // 認証されていない場合 => 認証処理を実行
    if (!appContainer.context.loading) {
      appContainer.setLoading(true);
      AuthService()
        .authentication(user.rawId)
        .then((result) => {
          if (result) {
            userContainer.setAuthenticatedUser(
              result.userId,
              result.hashedUserId,
              result.apiToken
            );
          } else {
            userContainer.setAuthInvalid();
          }
          appContainer.setLoading(false);
        })
        .catch((error) => {
          errorContainer.setDefaultError(user.id || user.rawId, error);
        });
    }
    return null;
  }
};

export default AuthGuardRoute;
